import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: "AIzaSyDya2iIB-_C63FD30tiu5S3HI53bXI0nVs",
  authDomain: "lushin-apexia.firebaseapp.com",
  projectId: "lushin-apexia",
  storageBucket: "lushin-apexia.firebasestorage.app",
  messagingSenderId: "154139921806",
  appId: "1:154139921806:web:a0345df7ffa14fea4de8df"
};

console.log('[Firebase] Initializing Firebase app with project:', firebaseConfig.projectId);
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Set persistence to local (default) to maintain auth state across page refreshes
setPersistence(auth, browserLocalPersistence).then(() => {
  console.log('[Firebase] Auth persistence set to LOCAL');
}).catch((error) => {
  console.error('[Firebase] Error setting auth persistence:', error);
});

// Log current auth state
auth.onAuthStateChanged((user) => {
  console.log('[Firebase] Global auth state changed:', {
    isLoggedIn: !!user,
    email: user?.email || 'none',
    uid: user?.uid || 'none',
    timestamp: new Date().toISOString()
  });
});

export const remoteConfig = getRemoteConfig(app);

console.log('[Firebase] Firebase initialized successfully');

export default app;